import { QueryClient, QueryClientProvider, hydrate } from '@tanstack/react-query'
import { RouterProvider, type AnyRouter } from '@tanstack/react-router'
import { AppRuntimeProvider, type SeaaBootstrap } from './lib/app-runtime'
import { I18nProvider } from './lib/i18n'
import { SiteContextProvider } from './lib/site-context'

export function createAppQueryClient(dehydratedState?: unknown) {
  const client = new QueryClient({
    defaultOptions: {
      queries: { retry: 1, refetchOnWindowFocus: false },
      mutations: { retry: 0 },
    },
  })
  if (dehydratedState) hydrate(client, dehydratedState)
  return client
}

export function SeaaApp({ router, bootstrap, queryClient = createAppQueryClient(bootstrap.dehydratedState) }: {
  router: AnyRouter
  bootstrap: SeaaBootstrap
  queryClient?: QueryClient
}) {
  return <AppRuntimeProvider value={bootstrap}>
    <QueryClientProvider client={queryClient}>
      <I18nProvider initialLocale={bootstrap.locale}>
        <SiteContextProvider initialSite={bootstrap.site} initialCustomerAppOrigin={bootstrap.customerAppOrigin} siteResolved={bootstrap.siteResolved} hostname={bootstrap.hostname}>
          <RouterProvider router={router} />
        </SiteContextProvider>
      </I18nProvider>
    </QueryClientProvider>
  </AppRuntimeProvider>
}
